import { useTranslate } from '@tolgee/react';
import { Divider, Tag } from 'antd';
import styled from '@emotion/styled';
import waitingPaySvg from './assets/waitingPay.svg';
import waitingDeliverySvg from './assets/waitingDelivery.svg';
import waitingSignSvg from './assets/waitingSign.svg';
import tradeSuccessSvg from './assets/tradeSuccess.svg';
import cancelSvg from './assets/cancel.svg';
import inCancellingSvg from './assets/inCancelling.svg';
import refundSvg from './assets/refund.svg';
import multipleSvg from './assets/multiple.svg';
import { ConversationTag } from '../ConvList/ConversationTag';
import { useOrderStatusLabel } from 'hooks/business/chat/useOrder';
import { getOrderErpStatusLabel } from 'services/i18n/enum/order';

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0;
  font-size: 14px;
  color: var(--fett-text-secondary);
  > img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  .ant-tag {
    border: none;
    color: var(--fett-scenario-success-text);
    margin-left: 8px;
    padding: 0 4px;
    font-size: 12px;
    background: var(--fett-surface-success-bg);
  }
`;

export interface TradeStatusProps {
  trade: Conversation.Trade.TradeWithLogistics;
}

const statusIconMap: Record<Conversation.Trade.Status, string> = {
  WAITING_PAY: waitingPaySvg,
  WAITING_DELIVERY: waitingDeliverySvg,
  WAITING_SIGN: waitingSignSvg,
  TRADE_SUCCESS: tradeSuccessSvg,
  CANCEL: cancelSvg,
  IN_CANCELING: inCancellingSvg,
  REFUND: refundSvg,
  MULTIPLE_STATUS: multipleSvg,
  UNKNOWN_ORDER_STATUS: cancelSvg,
};

const TradeStatus = (props: TradeStatusProps) => {
  const {
    trade: { tradeStatus, containsPreOrderItem, reputation, erpDetail: { erpTradeStatus } = {} },
  } = props;
  const { t } = useTranslate();
  const orderStatusLabel = useOrderStatusLabel(tradeStatus);

  return (
    <Container>
      <img src={statusIconMap[tradeStatus]} alt="none" />
      <span>{orderStatusLabel}</span>
      {erpTradeStatus ? (
        <>
          <Divider type="vertical" />
          <span style={{ marginRight: '6px' }}>ERP</span>
          <span>{getOrderErpStatusLabel(t, erpTradeStatus)}</span>
        </>
      ) : null}
      {containsPreOrderItem ? (
        <Tag color="green" title={t('domain.product.type.preOrder')}>
          {t('domain.product.type.preOrder')}
        </Tag>
      ) : null}
      {reputation && (
        <ConversationTag
          className="bg-[#F56E6E] ml-1"
          text={t('scene.chatWorkspace.orderTab.label.reputationImpact')}
        />
      )}
    </Container>
  );
};

export default TradeStatus;
